requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xCartHelper", {
      currentItemCount: 0,
      cartShareUrl: "",
      validated: true,
      openField: "",
      isOpenDiscountCodeMainCart: false,
      isCopiedCart: false,
      items: [],
      addItems: function (items, isOpenMiniCart = true) {
        const cartDrawerElement = document.querySelector(`#CartDrawer`);
        let sectionIdCartDrawer;
        if (cartDrawerElement) sectionIdCartDrawer = cartDrawerElement.dataset.sectionId;

        const sectionsToRender = this.getSectionsToRender(sectionIdCartDrawer);

        const sections = sectionsToRender.map((s) => s.id);

        const formData = {
          'items': items,
          'sections': sections
        }

        fetch(Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {"Content-Type": "application/json", Accept: "application/json"},
          body: JSON.stringify(formData)
        }).then(response => response.json())
          .then(response => {
            sectionsToRender.forEach((section => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement) {
                if (response.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
            }));

            Alpine.store("xMiniCart").reLoad(isOpenMiniCart);
          })
          .catch(error => {
            console.error(error);
          });
      },
      updateCart: function (data, needValidate = false) {
        const formData = JSON.stringify(data);
        fetch(Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {"Content-Type": "application/json", Accept: "application/json"},
          body: formData,
        }).then(() => {
          if (needValidate) this.validateCart();
        });
      },
      changeCart: function (data) {
        fetch(`${Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }).then((response) => response.text());
      },
      validateCart: function () {
        this.validated = true;

        document.dispatchEvent(new CustomEvent(`${CART_EVENT.validate}`));
      },
      goToCheckout(e) {
        this.validateCart();

        if (this.validated) {
          let formData = {
            attributes: {
              "collection-pagination": null,
              "blog-pagination": null,
              "choose_option_id": null,
              "datetime-updated": null,
              "datetime-created": null,
              [CART_ATTRIBUTES.product_comparison_options]: null,
              [CART_ATTRIBUTES.product_comparison_metafields]: null
            },
          };

          fetch(Shopify.routes.root + "cart/update", {
            method: "POST",
            headers: {"Content-Type": "application/json", Accept: "application/json"},
            body: JSON.stringify(formData),
          });
        } else {
          e.preventDefault();
        }
      },
      getSectionsToRender(sectionId) {
        let sectionsToRender = [
          {
            id: "cart-icon-bubble",
            selector: '#cart-icon-bubble'
          },
          {
            id: `${sectionId}`,
            selector: '.cart__shipping-and-delivery-wrapper'
          }
        ];

        if (window.Maximize.isCartPage) {
          sectionsToRender.push(
            {
              id: `${sectionId}`,
              selector: '#MainCart__Items'
            }
          )

          const sectionEle = document.querySelector(`.section-${sectionId}`);
          if (sectionEle) {
            const templateId = sectionEle.closest('.shopify-section').id
              .replace('cart-items', '')
              .replace('shopify-section-', '');
          }
        } else {
          if (sectionId) {
            sectionsToRender.push(
              {
                id: `${sectionId}`,
                selector: '#CartDrawer'
              }
            )
          }
        }

        return sectionsToRender;
      },
      generateUrl() {
        fetch(Shopify.routes.root + "cart.js", {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(response => response.json())
          .then(response => {
            this.items = response.items;

            const serialize = (obj) => {
              return Object.entries(obj).reduce((str, [key, value]) => str.concat(`${encodeURIComponent(key)}:${encodeURIComponent(value.toString())},`), "").slice(0, -1);
            };

            let filteredCart = this.items.map((item) => {
              return {
                id: item.variant_id,
                quantity: item.quantity
              };
            });

            filteredCart.push({share_cart: true});

            const queryString = filteredCart.map(serialize).join("&");

            this.cartShareUrl = `${window.location.origin}?&${queryString}`;
          });
      },
      copyURL(cartShareButton) {
        const cartShareInput = document.querySelector(`#cart-share`);
        if (cartShareInput) {
          cartShareInput.select();
          document.execCommand("copy");
          this.isCopiedCart = true;
        }
      },
      handleSharedCart() {
        if (location.search.includes("share_cart")) {
          const queryString = window.location.search.substring(1);
          let items = [];

          if (queryString.includes(`share_cart:true`)) {
            const idsAndQuantities = queryString.match(/id:\d+,quantity:\d+/g);

            if (idsAndQuantities) {
              idsAndQuantities.forEach(pair => {
                const [idPart, quantityPart] = pair.split(",");
                const id = idPart.split(":")[1];
                const quantity = quantityPart.split(":")[1];

                items.push({
                  id: Number(id),
                  quantity: Number(quantity)
                });
              });
            }
          }

          if (items.length) {
            this.addItems(items);
          }
        }
      },
      updateCurrentCountItem() {
        const cartBubbleContainer = document.querySelector("#cart-icon-bubble .cart-bubble__container");
        this.currentItemCount = parseInt(cartBubbleContainer && cartBubbleContainer.dataset.countItem ? cartBubbleContainer.dataset.countItem : 0);
      },
      closeField(isCloseMiniCart = false) {
        this.isCopiedCart = false;
        if (isCloseMiniCart) {
          const drawerTransitionDuration = parseInt(window.getComputedStyle(document.body).getPropertyValue('--drawer-transition-duration').replaceAll('ms', ''));
          setTimeout(() => {
            this.openField = "";
          }, drawerTransitionDuration)
        } else {
          this.openField = "";
        }
        Alpine.store('xFocusElement').removeTrapFocus();
      }
    });

    Alpine.data("xCart", (sectionId) => ({
      t: "",
      isLoading: false,
      updateItemQty(line, additionalFeePropertyValue) {
        let qty = parseInt(document.getElementById(`CartItemQuantity--${line}`).value);
        if (this.__validateQty(qty)) {
          this.__postUpdateItem(line, qty, additionalFeePropertyValue);
        }
      },
      minusItemQty(line, additionalFeePropertyValue) {
        let qty = parseInt(document.getElementById(`CartItemQuantity--${line}`).value);
        if (this.__validateQty(qty)) {
          if (qty > 0) {
            qty -= 1;
            document.getElementById(`CartItemQuantity--${line}`).value = qty;
          }
          this.__postUpdateItem(line, qty, additionalFeePropertyValue);
        }
      },
      plusItemQty(line, additionalFeePropertyValue) {
        let qty = parseInt(document.getElementById(`CartItemQuantity--${line}`).value);
        if (this.__validateQty(qty)) {
          if (qty >= 0) {
            qty += 1;
            document.getElementById(`CartItemQuantity--${line}`).value = qty;
          }

          this.__postUpdateItem(line, qty, additionalFeePropertyValue);
        }
      },
      removeItem(line, additionalFeePropertyValue) {
        this.__postUpdateItem(line, 0, additionalFeePropertyValue, 0);
      },
      handleKeydown(evt, el) {
        if (evt.key !== "Enter") return;
        evt.preventDefault();
        el.blur();
        el.focus();
      },
      updateCartItem(line, errorMessage) {
        fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`, {
          method: "GET",
          headers: {
            Accept: "application/javascript",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.text())
          .then((text) => {
            const newCartSectionHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");

            const newCartWrapperHTML = newCartSectionHTML.querySelector(`.cart-wrapper-${sectionId}`);
            if (newCartWrapperHTML) {
              const oldCartItemEle = document.querySelector(`.cart-wrapper-${sectionId} .cart-item__wrapper[data-cart-item-line="${line}"]`);
              const newCartItemEle = newCartWrapperHTML.querySelector(`.cart-item__wrapper[data-cart-item-line="${line}"]`);

              if (oldCartItemEle && newCartItemEle) {
                oldCartItemEle.outerHTML = newCartItemEle.outerHTML;
              }

              this._addErrorMessage(line, errorMessage);
            }
          });
      },
      updateEstimateShippingCart(el, estimateShippingKey) {
        const attributeEstimateShipping = {};
        const estimateContentEle = el.querySelector('.estimate-content');
        if (estimateContentEle) {
          attributeEstimateShipping[estimateShippingKey] = estimateContentEle.innerHTML;

          Alpine.store('xCartHelper').updateCart({
            attributes: attributeEstimateShipping
          });
        }

      },
      updateEstimateShippingCartItem(el, line) {
        const quantityEle = document.querySelector(`#CartItemQuantity--${line}`);
        const qty = quantityEle ? parseInt(quantityEle.value) : 1;
        const properties = xParseJSON(el.dataset.properties);

        let updateData = {
          line: `${line}`,
          quantity: `${qty}`,
          properties: properties,
        };

        Alpine.store('xCartHelper').changeCart(updateData);
      },
      updateDate(date) {
        let formData = {
          attributes: {
            "datetime-updated": `${date}`,
          },
        };
        fetch(Shopify.routes.root + "cart/update", {
          method: "POST",
          headers: {"Content-Type": "application/json", Accept: "application/json"},
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .catch((error) => console.error(error));
      },
      _addErrorMessage(line, message) {
        const lineItemError = document.getElementById(`LineItemError-${line}`);

        if (!lineItemError) return;
        lineItemError.classList.remove("hidden");
        lineItemError.getElementsByClassName("cart-item__error-text")[0].innerHTML = message;
      },
      async handleUpdateAdditionalFeeData(additionalFeePropertyValue, additionalFeeItemsUpdate, additionalFeeItemsData, sectionsToRender, mainItemKey, qty, isUpdateError) {
        if (additionalFeePropertyValue != '') {
          if (isUpdateError) {
            await fetch(Shopify.routes.root + "cart.js", {
              method: "GET",
              headers: {
                "Content-Type": "application/json"
              }
            })
              .then(responseCart => responseCart.json())
              .then( async (responseCart) => {
                const items = responseCart.items;
                let newQty = qty;
                for(let i=0; i<items.length; i++) {
                  if (items[i].key == mainItemKey) {
                    newQty = items[i].quantity;
                    break;
                  }
                }
                additionalFeeItemsUpdate.map(item => {
                  additionalFeeItemsData.updates[item.itemKey] = newQty
                })
                
                await fetch(window.Maximize.routes.cartUpdate, {
                  method: "POST",
                  headers: {
                    Accept: "application/javascript",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(additionalFeeItemsData),
                })
                  .then(responseAdditionalFee => responseAdditionalFee.json())
                  .then((responseAdditionalFee) => {
                    sectionsToRender.forEach((section) => {
                      const sectionElement = document.querySelector(section.selector);
                      if (sectionElement) {
                        if (responseAdditionalFee.sections[section.id]) sectionElement.innerHTML = getSectionInnerHTML(responseAdditionalFee.sections[section.id], section.selector);
                      }
                    });
                  })
              });
            return;
          } else {
            additionalFeeItemsUpdate.map(item => {
              additionalFeeItemsData.updates[item.itemKey] = qty
            })
            
            return await fetch(window.Maximize.routes.cartUpdate, {
              method: "POST",
              headers: {
                Accept: "application/javascript",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(additionalFeeItemsData),
            })
              .then(responseAdditionalFee => responseAdditionalFee.json())
          }
        }
        return;
      },
      __postUpdateItem(line, qty, additionalFeePropertyValue, wait = 500) {
        clearTimeout(this.t);

        const func = () => {
          this.isLoading = true;

          const sectionsToRender = Alpine.store("xCartHelper").getSectionsToRender(sectionId);
          const sections = sectionsToRender.map((s) => s.id);

          let updateData = {
            line: `${line}`,
            quantity: `${qty}`,
            sections: sections
          };

          const loadingEle = document.getElementById(`CartItem__Loading__${line}`);
          if (loadingEle) {
            loadingEle.classList.remove('hidden');
          }
          let removeEl = document.getElementById(`CartItemRemove-${line}`);
          if (removeEl) {
            removeEl.style.display = "none";
          }

          const additionalFeeItemsData = {
            updates: {},
            sections: sections
          }
          const additionalFeeItemsUpdate = []
          let mainItemKey = ''

          // Preprocess data additional fee
          if (additionalFeePropertyValue != '') {
            Array.from(document.querySelectorAll(`.cart-item__wrapper[data-additional-fee-property="${additionalFeePropertyValue}"]`)).map(item => {
              if (additionalFeePropertyValue.split('_')[0] != item.dataset.variantId) {
                additionalFeeItemsUpdate.push({
                  itemKey: item.dataset.cartItemKey,
                  itemLine: item.dataset.cartItemLine
                })
              }
              else {
                mainItemKey = item.dataset.cartItemKey
              }
            })
          }

          // call api update cart
          fetch(window.Maximize.routes.cartChange, {
            method: "POST",
            headers: {
              Accept: "application/javascript",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updateData),
          })
            .then((response) => {
              if (!response.ok && response.errors) {
                this._addErrorMessage(line, response.message);
                this.updateCart(line);
              }

              return response.json();
            })
            .then(async (response) => {
              if (response.status === 422) {
                await this.handleUpdateAdditionalFeeData(additionalFeePropertyValue, additionalFeeItemsUpdate, additionalFeeItemsData, sectionsToRender, mainItemKey, qty, true)

                this.updateCartItem(line, response.message);
              } else {
                if (response.errors) {
                  this._addErrorMessage(line, response.errors);
                } else {
                  const finalResponse = await this.handleUpdateAdditionalFeeData(additionalFeePropertyValue, additionalFeeItemsUpdate, additionalFeeItemsData, sectionsToRender, mainItemKey, qty, false) || response

                  sectionsToRender.forEach((section) => {
                    const sectionElement = document.querySelector(section.selector);
                    if (sectionElement) {
                      if (section.selector === "#MainCart__Items") {
                        const mainCartElement = sectionElement;
                        mainCartElement.classList.add("disable-fade-element")
                      }
                      if (finalResponse.sections[section.id]) sectionElement.innerHTML = getSectionInnerHTML(finalResponse.sections[section.id], section.selector);
                    }
                  });

                  if (!window.Maximize.isCartPage) {
                    if (Alpine.store("xProductRecommendations")) {
                      Alpine.store("xProductRecommendations").updateCartDrawerUpsellStatus();
                    }
                  }

                  const currentItemCount = Alpine.store("xCartHelper").currentItemCount;
                  if (currentItemCount !== finalResponse.item_count) {
                    Alpine.store("xCartHelper").currentItemCount = finalResponse.item_count;
                    document.dispatchEvent(new CustomEvent(`${CART_EVENT.cartUpdate}`, {
                      bubbles: true,
                      detail: {
                        isItemCountChanged: true,
                      }
                    }));
                  }
                }
              }
            })
            .catch(e => {
              console.error("Error updating cart item:", e);
            })
            .finally(() => {
              this.isLoading = false;
              if (loadingEle) {
                loadingEle.classList.add('hidden');
              }
            });
        };

        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      __validateQty: function (number) {
        return !(parseFloat(number) !== parseInt(number) && isNaN(number));
      },
    }));

    Alpine.store("xMiniCart", {
      isOpen: false,
      isOpenUpsell: false,
      isLoading: false,
      isOpeningCartDrawer: false,
      needReload: false,
      async reLoad(isOpenMiniCart = false) {
        this.isLoading = true;
        const sections = Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id).join(',');
        await fetch(
          `${window.location.pathname}?sections=${sections}`
        )
          .then(response => response.json())
          .then(response => {
            Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
              const sectionElement = document.querySelector(section.selector);
              if (sectionElement && response[section.id]) {
                sectionElement.innerHTML = getSectionInnerHTML(response[section.id], section.selector);
              }
            }));

            this.isLoading = false;

            if (!this.isOpen && isOpenMiniCart) {
              this.isOpen = true;
              Alpine.store("xMaximizeDrawer").handleOpen('#CartDrawer__Container');
            }
          });
      },
      handleOpen() {
        if (window.location.pathname === '/cart') return;

        Alpine.store("xMaximizeDrawer").handleOpen('#CartDrawer__Container');
        requestAnimationFrame(() => {
          this.isOpeningCartDrawer = true;
          const drawerTransitionDuration = parseInt(window.getComputedStyle(document.body).getPropertyValue('--drawer-transition-duration').replaceAll('ms', ''));

          this.isOpen = true;
          setTimeout(() => {
            this.isOpeningCartDrawer = false;
          }, drawerTransitionDuration)

          if (Alpine.store("xCartHelper").currentItemCount === 0) {
            this.isOpenUpsell = false;
          } else {
            if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
              if (Alpine.store("xProductRecommendations")) {
                Alpine.store("xProductRecommendations").updateCartDrawerUpsellStatus();
              }
            }
          }
        });
      },
      handleClose() {
        if (this.isOpeningCartDrawer) return;

        Alpine.store("xMaximizeDrawer").handleClose();
        requestAnimationFrame(() => {
          this.isOpen = false;
          if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) {
            this.isOpenUpsell = false;
          }
          Alpine.store("xCartHelper").closeField(true)
          Alpine.store('xFocusElement').removeTrapFocus();
        });
      }
    });

    Alpine.store('xCartAnalytics', {
      viewCart() {
        fetch(
          '/cart.js'
        ).then(response => {
          return response.text();
        }).then(cart => {
          cart = JSON.parse(cart);
          if (cart.items.length > 0) {
            Shopify.analytics.publish('view_cart', {'cart': cart});
          }
        });
      }
    });
  })
})
